import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';

import { adminSaga } from './saga';
import { createSlice } from 'utils/@reduxjs/toolkit';

/* import {
  sliceLoadFail,
  sliceLoadStart,
  sliceSpecialLoadFail,
  sliceSpecialLoadHandle,
} from 'utils/tools/slice-actions'; */

export const initialState = {
  loading: false,
  error: null,
  isAdminAuthorized: true,
  adminData: [],
};

const slice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    /* fetchActionStart(state, action) {
        sliceLoadStart(state);
      }, 
      fetchActionSuccess(state, action) {
      state.adminData = action?.payload;
      state.loading = false;
      },
      fetchActionError(state,action) {
        sliceLoadFail(state, action);
      },
    */
    /* 
      updateActionStart(state, action) {
        sliceSpecialLoadHandle(
          state,
          'actionFor',
          true,
        );
      }, 
      updateActionEnd(state, action) {
        const {actionFor, data = null} = action.payload;
        sliceSpecialLoadHandle(state, actionFor, false, data);
      },
      updateActionError(state, action) {
        const {actionFor, error} = action.payload
        sliceSpecialLoadFail(
          state,
          actionFor,
          error,
        );
      },
    */
    /* 
    fetchPageActionStart(state, action) {
      sliceSpecialLoadHandle(
        state,
        actionFor,
        true,
      );
    }, 
    fetchPageActionEnd(state, action) {
      const {actionFor, data, page_number,page_size,total} = action.payload
      sliceSpecialLoadHandle(state, actionFor, false, data, page_number, page_size, total);
    },
    fetchPageActionError(state, action) {
      const {actionFor, error} = action.payload
      sliceSpecialLoadFail(
        state,
        actionFor,
        error,
      );
    },
    */
  },
});

export const { actions: adminActions } = slice;

export const useAdminSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: adminSaga });
  return { actions: slice.actions };
};
